import React, { useState } from 'react';
import { Instagram, MessageCircle, Globe, Facebook, MoreVertical, Phone } from 'lucide-react';

export default function InfoRedes() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoveredProduct, setHoveredProduct] = useState(null);

  const socialLinks = [
    {
      name: 'Facebook',
      icon: Facebook,
      url: 'https://www.facebook.com/people/TT-Software-de-M%C3%A9xico/100069325536914/',
      iconColor: 'white'
    },
    {
      name: 'Instagram',
      icon: Instagram,
      url: 'https://www.instagram.com/tyt.software/#',
      iconColor: 'white'
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      url: 'https://api.whatsapp.com/send/?phone=528331083078&text&type=phone_number&app_absent=0',
      iconColor: 'white'
    },
    {
      name: 'T&T SOFTWARE DE MÉXICO',
      icon: Globe,
      url: 'https://www.tytsoftwaredemexico.com/',
      iconColor: 'white'
    },
    {
      name: '(833) 213 15 22\n(833) 213 13 22',
      icon: Phone,
      url: 'tel:+528332131522',
      iconColor: 'white',
      isPhone: true
    }
  ];

  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #7394ffff 0%, #7696f7ff 20%, #00316dff 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
    },
    content: {
      maxWidth: '42rem',
      width: '100%'
    },
    header: {
      textAlign: 'center',
      marginBottom: '2rem',
      position: 'relative'
    },
    logo: {
      width: '10rem',
      height: '10rem',
      marginBottom: '1.5rem'
    },
    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: 'white',
      marginBottom: '0.75rem',
      letterSpacing: '-0.025em'
    },
    description: {
      fontSize: '1rem',
      color: 'white',
      margin: '0.5rem 0',
      lineHeight: '1.5'
    },
    productsSection: {
      textAlign: 'center',
      marginBottom: '2rem'
    },
    productsTitle: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: 'white',
      marginBottom: '1rem'
    },
    productsGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '1rem',
      marginBottom: '2rem'
    },
    productCard: {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      borderRadius: '1rem',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '0.5rem',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      textDecoration: 'none',
      cursor: 'pointer',
      transition: 'all 0.3s',
      transform: 'scale(1)'
    },
    productIcon: {
      width: '3.5rem',
      height: '3.5rem',
      borderRadius: '0.75rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '2rem'
    },
    productName: {
      fontSize: '0.875rem',
      fontWeight: '600',
      color: 'white',
      margin: 0
    },
    linksContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    },
    link: {
      display: 'block',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.2)',
      borderRadius: '0.75rem',
      padding: '1.25rem',
      textDecoration: 'none',
      transition: 'all 0.3s',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
      position: 'relative',
      overflow: 'hidden'
    },
    linkContent: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative'
    },
    linkLeft: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem'
    },
    iconBox: {
      width: '3rem',
      height: '3rem',
      borderRadius: '0.75rem',
      backgroundColor: 'rgba(255, 255, 255, 0.25)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: 'transform 0.3s'
    },
    linkName: {
      fontSize: '1.125rem',
      fontWeight: '600',
      color: 'white',
      margin: 0
    },
    linkSubtitle: {
      fontSize: '0.875rem',
      color: '#e5e7eb',
      margin: '0.25rem 0 0 0'
    },
    bottomBorder: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '0.25rem',
      background: 'linear-gradient(to right, #10b981, #06b6d4)',
      opacity: 0,
      transition: 'opacity 0.3s',
      borderBottomLeftRadius: '0.5rem',
      borderBottomRightRadius: '0.5rem'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        {/* Header */}
        <div style={styles.header}>
          {/* Logo Circle */}
          <div style={styles.logoCircle}>
            <img
              src="https://www.tytsoftwaredemexico.com/static/media/tyt_logo.89f7a9b6.png"
              alt="T&T Software Logo"
              style={styles.logo}
            />
          </div>
          <p style={styles.description}>
            Somos T&T SOFTWARE DE MÉXICO Optimizamos y<br />
            automatizamos los procesos administrativos de las empresas.
          </p>

          {/* Products Section */}
          <div style={styles.productsSection}>
            <p style={styles.productsTitle}>Nuestros Productos:</p>
            <div style={styles.productsGrid}>
              <a
                href="https://tytsoftwaredemexico.com/tterp"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...styles.productCard,
                  transform: hoveredProduct === 0 ? 'scale(1.05)' : 'scale(1)'
                }}
                onMouseEnter={() => setHoveredProduct(0)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div style={styles.productIcon}>
                  <img
                    src="https://tytsoftwaredemexico.com/static/media/tyterp.eaa7f05f.png"
                    alt="T&T ERP"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <span style={styles.productName}>T&T ERP</span>
              </a>
              <a
                href="https://tytsoftwaredemexico.com/ttnomina"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...styles.productCard,
                  transform: hoveredProduct === 1 ? 'scale(1.05)' : 'scale(1)'
                }}
                onMouseEnter={() => setHoveredProduct(1)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div style={styles.productIcon}>
                  <img
                    src="https://tytsoftwaredemexico.com/static/media/tytnomina.a095cbd7.png"
                    alt="T&T NÓMINA"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <span style={styles.productName}>T&T NÓMINA</span>
              </a>
              <a
                href="https://tytsoftwaredemexico.com/ttcfdi"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...styles.productCard,
                  transform: hoveredProduct === 2 ? 'scale(1.05)' : 'scale(1)'
                }}
                onMouseEnter={() => setHoveredProduct(2)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div style={styles.productIcon}>
                  <img
                    src="https://tytsoftwaredemexico.com/static/media/tytcfdi.c5b7a482.png"
                    alt="T&T CFDI"
                    style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                  />
                </div>
                <span style={styles.productName}>T&T CFDI</span>
              </a>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div style={styles.linksContainer}>
          {socialLinks.map((link, index) => {
            const Icon = link.icon;
            const isHovered = hoveredIndex === index;

            return (
              <a
                key={index}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  ...styles.link,
                  transform: isHovered ? 'scale(1.02)' : 'scale(1)',
                  boxShadow: isHovered
                    ? '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
                    : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <div style={styles.linkContent}>
                  <div style={styles.linkLeft}>
                    <div style={{
                      ...styles.iconBox,
                      transform: isHovered ? 'scale(1.1)' : 'scale(1)'
                    }}>
                      <Icon style={{ width: '1.75rem', height: '1.75rem', color: link.iconColor }} />
                    </div>
                    <div>
                      <h3 style={{
                        ...styles.linkName,
                        whiteSpace: link.isPhone ? 'pre-line' : 'normal'
                      }}>
                        {link.name}
                      </h3>
                    </div>
                  </div>

                  <div style={{ color: 'rgba(255, 255, 255, 0.5)' }}>
                    <MoreVertical style={{ width: '1.25rem', height: '1.25rem' }} />
                  </div>
                </div>

                {/* Bottom border on hover */}
                <div style={{
                  ...styles.bottomBorder,
                  opacity: isHovered ? 1 : 0
                }}></div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}